<template>
  <div
    class="list-row flex items-center justify-between gap-3 border-t border-theme-transparent py-2.5 first:border-t-0"
  >
    <slot />
  </div>
</template>
